import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-fill align-items-start" }
const _hoisted_2 = { class: "flex-column" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h5", { class: "mb-0" }, "Nulstil kodeord", -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "d-flex justify-content-end" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Afbryd")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Nulstil kodeord")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VDValidationErrors = _resolveComponent("VDValidationErrors")!
  const _component_o_input = _resolveComponent("o-input")!
  const _component_o_field = _resolveComponent("o-field")!
  const _component_Button = _resolveComponent("Button")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    draggable: false,
    modal: true,
    dismissableMask: true,
    visible: _ctx.isVisible,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          (_ctx.user)
            ? (_openBlock(), _createBlock("small", _hoisted_4, _toDisplayString(_ctx.user.firstname) + " " + _toDisplayString(_ctx.user.lastname) + " | " + _toDisplayString(_ctx.user.email), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_Button, {
          onClick: _ctx.hide,
          class: "link me-2"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          disabled: _ctx.resetUserPasswordMutation.loading.value,
          onClick: _ctx.primaryButtonPressed,
          class: "primary"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, {
              class: "me-2",
              spin: _ctx.resetUserPasswordMutation.loading.value,
              icon: 
              _ctx.resetUserPasswordMutation.loading.value
                ? ['fas', 'spinner']
                : ['fas', 'check']
            
            }, null, 8, ["spin", "icon"]),
            _hoisted_7
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_VDValidationErrors, {
        errors: _ctx.v$.$errors
      }, null, 8, ["errors"]),
      _createVNode(_component_o_field, {
        class: "mb-2",
        variant: _ctx.v$.newPassword.$error ? 'danger' : '',
        label: "Nyt password"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_o_input, {
            modelValue: _ctx.resetPasswordInput.newPassword,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.resetPasswordInput.newPassword = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["variant"]),
      _createVNode(_component_o_field, {
        variant: _ctx.v$.newPasswordRepeated.$error ? 'danger' : '',
        label: "Gentag nyt password"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_o_input, {
            modelValue: _ctx.resetPasswordInput.newPasswordRepeated,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.resetPasswordInput.newPasswordRepeated = $event)),
            type: "password"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["variant"])
    ]),
    _: 1
  }, 8, ["visible"]))
}